var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-bottom",attrs:{"id":"footer"}},[_c('img',{staticClass:"logo-footer iluni",attrs:{"src":_vm.logoIluniUi,"alt":"logo_iluniui"}}),_c('img',{staticClass:"logo-footer uiconnect",attrs:{"src":_vm.logoUiConnect,"alt":"logo_uiconnect_lowres"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }